import 'stylesheets/pages/event/mystery_ticket/index/style';
import SmoothScroll from 'smooth-scroll';

new SmoothScroll('a[href*="#"]', {
  easing: 'easeInOutCubic',
  offset: 20,
  updateURL: false,
  popstate: true,
});

const $nav = document.querySelector('.FA-Nav');
if ($nav) {
  window.addEventListener('scroll', () => {
    const dy = document.querySelector('.js-Nav').offsetTop;
    if (window.pageYOffset > dy) {
      $nav.classList.add('fixed');
    } else {
      $nav.classList.remove('fixed');
    }
  });
}
